import React from "react";
import {Controller} from "react-hook-form";
import {CheckboxInput} from "./CheckboxInput";

interface FormCheckboxInputProps {
    control: any;
    name: string;
    label?: any;
    checked?: boolean;
    className?: string;
}

export const FormCheckboxInput = ({ className, checked, label, name, control}: FormCheckboxInputProps) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, ...rest }) => {
                return (
                    <CheckboxInput
                        className={className}
                        name={name}
                        label={label}
                        checked={field.value || checked}
                        value={field.value}
                        onChange={field.onChange}
                        errorMessage={rest.formState.errors[name]?.message as string || ''}
                    />
                )
            }}
        />
    );
}